import { render, staticRenderFns } from "./postContentBlock.vue?vue&type=template&id=ec2c87de&scoped=true"
import script from "./postContentBlock.vue?vue&type=script&lang=js"
export * from "./postContentBlock.vue?vue&type=script&lang=js"
import style0 from "./postContentBlock.vue?vue&type=style&index=0&id=ec2c87de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2c87de",
  null
  
)

export default component.exports